import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Badge } from "./ui/badge";

export function SiteHeader({ name, plan, status }: any) {
  return (
    <header className="group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 flex h-12 shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        <h1 className="text-base font-medium">{name}</h1>
      </div>

      <div className="flex w-auto">
        {status === "active" && (
          <>
            <span className="w-[100px]">Plan Actual:</span>
            <Badge className="ml-4 mr-3">{plan?.toUpperCase()}</Badge>
          </>
        )}
      </div>
    </header>
  );
}
